import React from "react";
import PropTypes from "prop-types";
import { TestBox } from "../index";
import I18N from "../../I18N";
import "./dnsIpCompare.scss";

const DnsIpCompare = ({ results, handleReTest }) => {
  const { isLoading, error } = results;
  return (
    <TestBox
      testName={I18N.t("DNS_IP_COMPARE")}
      handleReTest={handleReTest}
      isLoading={isLoading}
      error={error}
    >
      <ul className="dns-ip-compare">
        {results &&
          Object.keys(results).map(item => (
            <li key={item} className="dns-ip-compare__item">
              <span>{item}</span>
              <span>{results[item]}</span>
            </li>
          ))}
      </ul>
    </TestBox>
  );
};

DnsIpCompare.propTypes = {
  results: PropTypes.object.isRequired,
  handleReTest: PropTypes.func.isRequired
};
DnsIpCompare.defaultProps = {};

export default DnsIpCompare;
